module.exports = __webpack_public_path__ + "img/taskforce.66f606dc.png";